__webpack_require__.p = "https://events.sihs.org.pk/";